// extracted by mini-css-extract-plugin
export default {"container":"H0-z","heading":"I0-z","links":"J0-z","copy":"K0-z","subCopy":"L0-z","linksLeft":"M0-z","linksCenter":"N0-z","linksRight":"O0-z","link":"P0-z","onlyLink":"Q0-z"};